// removed by extract-text-webpack-plugin
module.exports = {"langSelector":"_1Cl541lX351DzF3P0GcyfX","toggle":"_1ghjfYrLOhvbxzzPHijWuP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LangSelector/LangSelector.scss
// module id = 1277
// module chunks = 1